module.exports = __webpack_public_path__ + "img/green_099.0013c83d.png";